<div class="subtasks-list">
  <ng-container *ngFor="let task of taskList$ | async; trackBy: trackBy">
    <list-tasks-single-task
      *ngIf="!task.deleted"
      [task]="task"
      [groupId]="service?.parentTask?.taskGroup?.id || service?.parentTask?.workspaceTaskGroup?.id || 0"
      [parentTask]="service?.parentTask"
      [hideHierarchyIndicator]="true"
      [showRemoveAction]="true"
      [simplifiedSubtaskLayout]="true"
      [status]="getTaskStatus(task)"
      (statusUpdated)="onTaskStatusChanged($event)"
      (removeRequested)="confirmRemoveTask($event)"
    />
  </ng-container>
</div>
